
import React from 'react';
import SummaryItem from '../SummaryItem';

const ParentCareTakerInfo = props => {

    const {
        idx,
        parentCaretaker
    } = props;

    if(!parentCaretaker) {
        return null;
    }

    return (
        <SummaryItem
            textCode = 'common.parent_caretaker'
            value = { parentCaretaker }
            desc = {
                [
                    [
                        `taxHousehold.householdMember[${ idx }].parentCaretaker`
                    ]
                ]
            }
        />
    );
};

export default ParentCareTakerInfo;